import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Text as PaperText } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import { GaugeStats } from "../GaugeStats";
import {
	CHART_DIMENSIONS,
	CONFIDENCE_LEGEND,
	CONFIDENCE_LEGEND_COLORS,
	SPACING,
} from "../constants";
import type { ConfidenceLegendColorKey } from "../constants";
import type { CircularGaugeGridData } from "../types";

type CircularGaugeGridProps = {
	gauges: CircularGaugeGridData;
};

export const CircularGaugeGrid = ({ gauges }: CircularGaugeGridProps) => {
	const theme = useAppTheme();
	const config = CHART_DIMENSIONS.circularGaugeGrid;

	const gaugeData = gauges.map((gauge) => ({
		label: gauge.label,
		progress: gauge.percentage,
		value: gauge.fraction,
	}));

	return (
		<Box style={{ width: "100%" }}>
			<Box paddingHorizontal={SPACING.card}>
				<GaugeStats gauges={gaugeData} size="medium" />
			</Box>

			<Box
				flexDirection="row"
				justifyContent="center"
				flexWrap="wrap"
				paddingHorizontal={SPACING.card}
				style={{
					marginTop: config.gap,
					columnGap: 24,
					rowGap: 12,
				}}
			>
				{CONFIDENCE_LEGEND.map((item) => {
					const colorKey = item.colorKey as ConfidenceLegendColorKey;
					const color =
						(theme.colors[colorKey as keyof typeof theme.colors] as
							| string
							| undefined) ?? CONFIDENCE_LEGEND_COLORS[colorKey];
					return (
						<Box
							key={item.range}
							flexDirection="row"
							alignItems="center"
							gap={4}
						>
							<MaterialCommunityIcons
								name={item.icon as "emoticon-sad-outline"}
								size={config.legendIconSize}
								color={color}
							/>
							<PaperText
								variant="labelSmall"
								style={{ color: theme.colors.onSurfaceVariant }}
							>
								{item.range}
							</PaperText>
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};
